export const menuData = [
  {
    label: '產品',
    value: '1',
    icon: '',
    // unfold: false,
    href: '',
    children: [
      {
        value: '1-1',
        label: '旅遊保險',
        icon: 'travel',
        children: [
          {
            value: '1-1-1',
            label: '智在遊',
            // // icon: true,,
            href: '/ch/Travel-Smart/Application',
          },
          {
            value: '1-1-2',
            label: '「智易 Go」大灣區旅遊保',
            // // icon: true,,
            href: '/ch/GBATravel/Information',
          },
          {
            value: '1-1-3',
            label: '智醒工作假期保',
            // // icon: true,,
            href: '/ch/Working-Holiday/Information',
          },
          {
            value: '1-1-4',
            label: '「香港通」旅遊保險-至尊計劃',
            // // icon: false,,
            href: '/ch/inbound-travel/Information',
          },
          {
            value: '1-1-5',
            label: '智醒海外升學保',
            // // icon: true,,
            href: '/ch/Overseas-StudySafe/Information',
          },
        ],
        // onLine: {
        //   label: '可網上投保產品',
        // },
      },
      {
        value: '1-2',
        label: '生活保險',
        icon: 'gi',
        children: [
          {
            value: '1-2-1',
            label: '家居至專寶',
            // // icon: true,,
            href: '/ch/HomeSafe-Protection-Insurance/Information',
          },
          {
            value: '1-2-2',
            label: '智駕樂',
            // // icon: true,,
            href: '/ch/smartProDrive/Information',
            tag: '新',
          },
          {
            value: '1-2-3',
            label: '家傭至專寶',
            // // icon: true,,
            href: '/ch/MaidSafe-Insurance/Information',
          },
          {
            value: '1-2-4',
            label: '「智Fit」運動保險',
            // // icon: true,,
            href: '/ch/SmartFit/Information',
          },

          {
            value: '1-2-5',
            label: '裝修寶',
            // // icon: true,,
            href: '/ch/Decoration-Insurance/Information',
            tag: '新',
          },
          {
            value: '1-2-6',
            label: '個人意外保險',
            // // icon: true,,
            href: '/ch/Personal-Accident-Insurance/Information',
          },
          {
            value: '1-2-7',
            label: '「愛.寵物」保險計劃',
            // // icon: true,,
            href: '/ch/lovepet/Information',
          },
          {
            value: '1-2-8',
            label: '個人意外至尊寶',
            // icon: false,,
            href: '/ch/personal-accidentsafe/Information',
          },
          {
            value: '1-2-9',
            label: '「愛.寵物」門診醫療保',
            // icon: true,,
            href: '/ch/LovePet-Outpatient-Insurance/Information',
          },
          {
            value: '1-2-10',
            label: '火險',
            // icon: false,,
            href: '/ch/fire-insurance/Information',
          },
          {
            value: '1-2-11',
            label: '大班高爾夫球保險',
            // icon: true,,
            href: '/ch/taipan-golfersafe/Information',
          },
          {
            value: '1-2-12',
            label: '僱員補償保險',
            // icon: false,,
            href: '/ch/employees-compensation-insurance/Information',
          },
          {
            value: '1-2-13',
            label: '高爾夫球保險',
            // icon: true,,
            href: '/ch/golfersafe/Information',
          },
        ],
        // onLine: {
        //   label: '可網上投保產品',
        // },
      },
      {
        value: '1-3',
        label: '商業保險',
        icon: 'suitcase',
        children: [
          {
            value: '1-3-1',
            label: '商業至尊寶',
            full: true,
            href: '/ch/businesssafe-insurance/Information',
          },
        ],
      },
      {
        value: '1-4',
        type: 'right',
        label: '個人醫療保險',
        icon: 'heart',
        children: [
          {
            value: '1-4-1-1',
            label: '藍十字「愛自己」自願醫保計劃',
            // icon: true,,
            tag: '新',
            href: '/ch/VHIS/love-yourself-vhis/information',
          },
          {
            value: '1-4-2',
            label: '「大亨」醫療保險計劃',
            // icon: false,,
            href: '/ch/tycoon-medical-insurance-plan/Information',
          },
          {
            value: '1-4-1',
            label: '藍十字尊悅自願醫保計劃',
            // icon: true,,
            href: '/ch/Dynasty-VHIS/Information',
          },
          {
            value: '1-4-4',
            label: '「摯安心精選」醫療保險計劃',
            // icon: true,,
            href: '/ch/caring-medical-protection-plus/Application',
          },
          {
            value: '1-4-3',
            label: '「只衛您」超卓靈活自願醫保計劃',
            // icon: true,,
            href: '/ch/CareForYou-VHIS-Super-Flexi/Information',
          },
          {
            value: '1-4-6',
            label: '「只衛您」靈活自願醫保計劃',
            des: '（不適用於新申請）',
            // icon: false,,
            href: '/ch/CareForYou-VHIS-Flexi/Information',
          },
          {
            value: '1-4-5',
            label: '「只衛您」標準自願醫保計劃',
            // icon: true,,
            href: '/ch/CareForYou-VHIS-Standard/Information',
          },
          {
            value: '1-4-7',
            label: '轉工醫療保障',
            // icon: true,,
            full: true,
            href: '/ch/Job-Changer-Medical-Protection/Information',
          },
          {
            value: '1-4-8',
            label: '一站式門診醫療寶',
            // icon: true,,
            full: true,
            href: '/ch/all-in-one-outpatient-insurance/Information',
          },
          {
            value: '1-4-9',
            label: '護齒保險計劃',
            // icon: true,,
            full: true,
            href: '/ch/dental-plan/Information',
          },
        ],
        // onLine: {
        //   label: '可網上投保產品',
        // },
      },

      {
        value: '1-5',
        type: 'right',
        label: '團體醫療保險',
        icon: 'heart',
        children: [
          {
            value: '1-5-1',
            label: '僱員醫療保障計劃',
            full: true,
            href: '/ch/employee-medical-care-plan/Information',
          },
          {
            value: '1-5-2',
            label: '藍十字僱員危疾保障計劃',
            tag: '新',
            full: true,
            href: '/ch/employee-critical-illness-care-plan/Information',
          },
        ],
      },
      {
        value: '1-6',
        type: 'right',
        label: '健康檢查',
        icon: 'note',
        children: [
          {
            value: '1-6-1',
            label: '防癌檢查計劃',
            full: true,
            href: '/ch/cancer-screening/Information',
          },
          {
            value: '1-6-2',
            label: '定期身體檢查及疫苗注射計劃',
            full: true,
            href: '/ch/preventive-checkup-immunisation/Information',
          },
          {
            value: '1-6-3',
            label: '明康醫療體檢計劃',
            full: true,
            href: '/ch/u-care-medical-checkup/Information',
          },
        ],
      },
    ],
  },
  {
    label: '服務',
    value: '2',
    children: [
      {
        value: '2-1',
        label: '保單服務',
        icon: 'travel',
        foldState: false,
        children: [
          {
            value: '2-1-1',
            label: '續保',
            // icon: false,,
            // full: true,
            href: '/renewal/ch/home',
          },
          {
            value: '2-1-2',
            label: '保費付款匯率',
            // icon: false,,
            // full: true,
            href: '/ch/Exchange-Rates/Information',
          },
          {
            value: '2-1-3',
            label: '自願醫保計劃轉換',
            // icon: false,,
            // full: true,
            tag: '新',
            href: '/ch/VHIS-Migration/Application',
          },
          {
            value: '2-1-4',
            label: '更改資料',
            // icon: false,,
            // full: true,
            href: '/ch/OnlineEndorse/Home',
          },
        ],
      },
      {
        value: '2-2',
        label: '文件下載',
        icon: 'file',
        foldState: true,
        lock: true,
        children: [
          {
            value: '2-2-1',
            full: true,
            label:
              '提供各種保險相關的表格及文件，包括申請表格、產品單張、條款及細則等',
            href: '/ch/downloads/Others',
          },
        ],
      },
      {
        value: '2-3',
        label: '有用連結',
        icon: 'heart',
        type: 'right',
        children: [
          {
            value: '2-3-1',
            // full: true,
            label: '指定醫院名單',
            href: '/ch/hospitals-list/Information',
          },
          {
            value: '2-3-2',
            // full: true, 
            label: '零折舊率維修中心網絡',
            href: '/ch/motor-insurance/NilDepreciationOnRepairs',
          },
          {
            value: '2-3-3',
            // full: true,
            label: '汽車擋風玻璃維修中心網絡',
            href: '/ch/motor-insurance/WindscreenRepairesNetwork',
          },
          {
            value: '2-3-4',
            // full: true,
            label: '24小時道路緊急支援服務',
            href: '/ch/motor-insurance/ServiceHotlitagindscreenRepairesNetwork',
          },
          {
            value: '2-3-5',
            // full: true,
            label: '聯絡我們',
            href: '',
          },
        ],
      },
    ],
  },
  {
    label: '索償',
    value: '3',
    children: [
      {
        value: '3-1',
        label: '索償服務',
        icon: 'travel',
        foldState: true,
        children: [
          {
            value: '3-1-1',
            // icon: false,,
            label: '旅遊保險',
            href: '/online-eclaim/ch/travel-claim',
          },
          {
            value: '3-1-2',
            // icon: false,,
            label: '家傭保險',
            href: '/online-eclaim/ch/maid-claim',
          },
          {
            value: '3-1-3',
            icon: '',
            label: '寵物保險',
            href: '/online-eclaim/ch/pet-claim',
          },
          {
            value: '3-1-4',
            // icon: false,,
            label: '其他一般保險',
            href: '/ch/Online-Claim-GI/Submission',
          },
          {
            value: '3-1-5',
            // icon: false,,
            label: '汽車保險',
            href: '/ch/Online-Claim-Motor/Submission',
          },
          {
            value: '3-1-6',
            // icon: false,,
            label: '家居保險',
            href: '/ch/Online-Claim-HomeSafe/Submission',
          },
        ],
      },
      {
        value: '3-2',
        label: '索償文件下載',
        icon: 'file',
        foldState: false,
        type: 'right',
        children: [
          // {
          //   value: '3-2-1',
          //   // icon: false,,
          //   label: 'Super Care  醫保平台',
          //   href: 'https://supercare.bluecross.com.hk/Member/MemberDefault.aspx?CurrentLang=chi',
          // },
          {
            value: '3-2-2',
            // icon: false,,
            label: '索償手續及表格',
            href: '/ch/downloads/Claims-Form-Procedure',
          },
        ],
      },
    ],
  },
  {
    value: '4',
    icon: '',
    label: '網誌',
    target: '_blank',
    href: '/Blog',
  },
];

export const loginMenu = {
  label: '登入',
  value: '1',
  href: '/ch/Home/Index',
  children: [
    {
      value: '1-1',
      label: 'BlueCross+ 客戶平台',
      href: '/ch/welcome/Information',
      target: '_self',
      className: 'iron-header-loginPop-blueItem',
      id: 'home_cpLogin',
    },
    {
      value: '1-2',
      label: '至醒會',
      href: '/ch/SmartClub/Index',
      target: '_self',
      logout: true,
      className: 'iron-header-loginPop-blueItem',
      id: 'home_clubLogin',
    },
    {
      value: '1-3',
      label: 'Super Care 醫保平台',
      href: 'https://supercare.bluecross.com.hk/Member/MemberDefault.aspx?CurrentLang=chi',
      target: '_blank',
      className: 'iron-header-loginPop-blueItem',
      disabledDefaultA: true,
      id: 'home_superCareLogin',
    },

    // {
    //   value: '1-3',
    //   // icon: false,,
    //   label: 'Super Agent',
    //   href: 'https://superagent.bluecross.com.hk/superagent/',
    //   target: '_blank',
    // },
  ],
};

export const superCareInfo = {
  label: 'Super Care <br/> 醫保平台',
  target: '_blank',
  href: 'https://supercare.bluecross.com.hk/Member/MemberDefault.aspx?CurrentLang=chi',
};


export const headerTabs = [
  {
    href: '/ch/Home/Index',
    label:'個人客戶',
    value:1,
    active:true,
  },
 {
    href: '/ch/Commercial/Information',
    label:'公司客戶',
    value:2,
  }
];
